import React from 'react'
import {
  TextField,
  EmailField,
  SearchInput,
  ReferenceInput,
  AutocompleteInput,
  SelectInput,
  BooleanField,
  ReferenceField,
} from 'react-admin'
import GetAppIcon from '@mui/icons-material/GetApp'

import Datagrid from '../common/Datagrid'
import RecordSplitButton from '../common/buttons/RecordSplitButton'
import ResourceLinkField from '../common/fields/ResourceLinkField'
import List, { ListActions } from '../common/views/List'
import IconButton from '../common/buttons/IconButton'

import { API_URL } from '../../services/settings'

const leadStatusChoices = [
  { id: 'new', name: 'New' },
  { id: 'contacted', name: 'Contacted' },
  { id: 'qualified', name: 'Qualified' },
  { id: 'meeting_scheduled', name: 'Meeting Scheduled' },
  { id: 'proposal_sent', name: 'Proposal Sent' },
  { id: 'converted', name: 'Converted' },
  { id: 'unqualified', name: 'Unqualified' },
  { id: 'lost', name: 'Lost' },
  { id: 'nurturing', name: 'Nurturing' },
]

const leadSourceChoices = [
  { id: 'typeform', name: 'Typeform' },
  { id: 'referral', name: 'Referral' },
  { id: 'linkedin', name: 'LinkedIn' },
  { id: 'user', name: 'Manual' },
  { id: 'other', name: 'Other' },
]

const LeadListActions = (props) => (
  <ListActions {...props}>
    <IconButton
      icon={<GetAppIcon />}
      component="a"
      href={`${API_URL}/leads/export.xls`}
      target="_blank"
      rel="noopener noreferrer"
    >
      Export
    </IconButton>
  </ListActions>
)

const leadFilters = [
  <SearchInput source="q" alwaysOn />,
  <SelectInput source="status" choices={leadStatusChoices} alwaysOn />,
  <SelectInput source="source" choices={leadSourceChoices} alwaysOn />,
  <TextField source="campaign" />,
  <SelectInput source="archived" label="Status" choices={[
    { id: 'false', name: 'Active' },
    { id: 'true', name: 'Archived' },
  ]} />,
]

const LeadList = (props) => (
  <List
    {...props}
    filters={leadFilters}
    actions={<LeadListActions />}
    exporter={false}
    filterDefaultValues={{ archived: 'false' }}
  >
    <Datagrid>
      <ResourceLinkField label="Name" resource="leads" sortBy="full_name">
        <TextField source="full_name" />
      </ResourceLinkField>
      <EmailField source="email" />
      <TextField source="company" />
      <TextField source="source" label="Source" />
      <TextField source="status" label="Status" />
      <ReferenceField source="customer_id" reference="customers" allowEmpty linkType="show">
        <TextField source="name" />
      </ReferenceField>
      <BooleanField source="is_converted" label="Converted" />
      <RecordSplitButton />
    </Datagrid>
  </List>
)

export default LeadList
